module.exports = __webpack_public_path__ + "static/media/close.0af2e1e9.svg";